import createMuiTheme from "@material-ui/core/styles/createMuiTheme";

const theme = createMuiTheme({
    typography: {
        fontFamily: [
            'Orbitron'
        ]
    },
    overrides: {
        MuiButton: {
           root: {
               color:'#fff',
               backgroundImage: "linear-gradient(to right,#f41351,#eb1c23)",
               width:"170px",
               height:'50px',
               fontSize:'18px',
               padding: '15px 45px'

        },}
    }
});
export default theme;